(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-contact"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-ds-contact]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const trigger = root.querySelector('summary');
    const chat = root.querySelector('[data-ds-contact-chat]');
    const status = root.querySelector('[data-ds-contact-status]');
    const unread = root.querySelector('[data-ds-contact-unread]');
    const api = window.Tawk_API = window.Tawk_API || {};
    let requested = false;
    let chatOpen = false;
    let timeout;
    const closeMenu = () => { root.open = false; };
    const restore = () => {
      const focus = chatOpen;
      chatOpen = false;
      requested = false;
      clearTimeout(timeout);
      root.hidden = false;
      if (focus) trigger.focus({ preventScroll: true });
    };
    const hideWidget = () => {
      try {
        if (typeof api.hideWidget === 'function') api.hideWidget();
      } catch {}
    };
    const openChat = () => {
      if (typeof api.maximize !== 'function' || typeof api.showWidget !== 'function') return false;
      try {
        api.showWidget();
        api.maximize();
        clearTimeout(timeout);
        status.textContent = '';
        unread.hidden = true;
        closeMenu();
        chatOpen = true;
        root.hidden = true;
        return true;
      } catch {
        restore();
        status.textContent = status.dataset.unavailable;
        return false;
      }
    };
    const chain = (name, callback) => {
      const previous = api[name];
      api[name] = function (...args) {
        try {
          if (typeof previous === 'function') previous.apply(this, args);
        } finally {
          callback(...args);
        }
      };
    };
    chain('onBeforeLoad', () => { if (!requested) hideWidget(); });
    chain('onLoad', () => { if (requested) openChat(); else hideWidget(); });
    chain('onChatMaximized', () => { chatOpen = true; root.hidden = true; closeMenu(); });
    chain('onChatMinimized', () => { hideWidget(); restore(); });
    chain('onChatHidden', restore);
    chain('onChatMessageAgent', () => { if (!chatOpen) unread.hidden = false; });
    hideWidget();
    chat.addEventListener('click', () => {
      requested = true;
      if (openChat()) return;
      status.textContent = status.dataset.loading;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        requested = false;
        status.textContent = status.dataset.unavailable;
      }, 10000);
    });
    root.querySelector('[data-ds-contact-close]').addEventListener('click', () => { closeMenu(); trigger.focus(); });
    root.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    document.addEventListener('pointerdown', event => { if (root.open && !root.contains(event.target)) closeMenu(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && root.open) { closeMenu(); trigger.focus(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
